import ListStore from '../../../../shared-lib/stores/ListStore'
import CrmInvoiceModel from './CrmInvoiceModel'

export default class CrmInvoiceStore extends ListStore<CrmInvoiceModel>{
  fetchMethodName = 'crmInvoices'
  ModelClass = CrmInvoiceModel
}